module.exports = __webpack_public_path__ + "a0aedd3aab5016606bd5590dbc70af55.svg";